export default __webpack_public_path__ + "static/media/menu_agencies.9ec44a68.png";